import React from 'react'
import { Redirect } from 'react-router-dom'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import EditProject from './EditProject'
import BackButton from '../UI/BackButton'
import ProjectNotFound from './ProjectNotFound'
import LinearLoader from '../UI/LinearLoader'
import PageTitle from '../UI/PageTitle'

import Resource from '../../stores/resource'
const ProjectStore = Resource('projects')

class EditProjectPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      project: null,
      error: '',
      redirect: '',
      loading: true
    }
  }

  componentDidMount() {
    this._processProps(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this._processProps(nextProps)
  }

  _processProps = (props) => {
    const { match } = props
    const projectId = match.params.id || match.params.projectId
    ProjectStore.findBy({ id: projectId }, [
      'agency',
      'client',
      'agencyProducer',
      'directorOne',
      'directorTwo',
      'user'
    ])
      .then(result => this.setState({ project: result.data, loading: false }))
      .catch(error =>
        this.setState({ project: null, error: errors.unpack(error) })
      )
  }

  _closeErrorDialog = () => this.setState({ error: '' })

  render() {
    const { match } = this.props
    const { loading, project, error, redirect } = this.state

    // Handling all early return conditions
    if (redirect) return <Redirect push to={redirect} />
    if (loading) return <LinearLoader />
    if (!project) return <ProjectNotFound />

    const quoteId = match.params.quoteId
    const addNewQuote = Boolean(match.url.match(/\/quotes\/new$/))
    const cloneQuote = Boolean(match.url.match(/\/clone$/))

    return (
      <section>
        <header>
          <PageTitle>Edit Project</PageTitle>
        </header>

        <EditProject
          project={project}
          quoteId={quoteId}
          addNewQuote={addNewQuote}
          cloneQuote={cloneQuote}
        />
        <br />
        <BackButton />
        <BackButton
          style={{marginLeft: '15px'}}
          label="Project list"
          onTouchTap={() => this.setState({ redirect: '/projects' })}
        />

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}
        >
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </section>
    )
  }
}

export default EditProjectPage



// WEBPACK FOOTER //
// ./src/components/Projects/EditProjectPage.jsx